import axios from 'axios';

const AUTH_BASE = process.env.REACT_APP_AUTH_API_BASE || 'http://localhost:8003';

const authApi = axios.create({
  baseURL: AUTH_BASE,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Redirect to login on 401 (skip for /auth/me — handled by AuthContext)
authApi.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && !err.config?.url?.includes('/auth/me')) {
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default authApi;
